<template>
  <div class="exhibit-header" :style="coverStyle">
      <div class="overlay"></div>
      <div class="content">
          <div class="flex-shrink-0">
                  <img 
                    v-if="logoSrc"
                    :src="logoSrc"
                    @error="logoSrc = ''"
                    alt="Exhibit Logo"
                    class="exhibit-logo"
                  />
          </div>
      </div>
  </div>
</template>

<script setup>
import { defineProps, computed, ref, watch } from 'vue';
const logoSrc = ref("");
const props =defineProps({
  coverImage: String,
  logo: String,
  name: String,
  description: String
});

const coverStyle = computed(() => {
  return props.coverImage
    ? { backgroundImage: `url(${props.coverImage})` }
    : {};
});
watch(
  () => props.logo,
  (newLogo) => {
    logoSrc.value = newLogo;
  },
  { immediate: true }
);
</script>

<style scoped>
.exhibit-header {
  position: relative;
  width: 100%;
  height: 400px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.content {
  position: relative;
  z-index: 2;
  color: white;
}

.exhibit-logo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 15px;
}
</style>